module.exports = __webpack_public_path__ + "img/flounces_length.9d284bd0.png";